import { CHAT_USER } from "@chesshotel/constants";
import React from "react";
import Chat from "../../components/Chat";
import { chatCreated, useGamePlay } from "../../ducks/gamePlay";
import { useUser } from "../../ducks/user";
// import { websocket } from "../../services/websocket";
import { GamePlayWs } from "../../services/wsOutRoutes";

export function sendChat(msg: string) {
  GamePlayWs.sendChat(msg);
  chatCreated({ msg, type: CHAT_USER });
}

export default function GameChat() {
  const { chatMessages, opponent } = useGamePlay();
  const { username } = useUser();

  const chatProps = {
    chatMessages,
    username,
    opponentUsername: opponent.username,
    sendChat,
  };

  return <Chat {...chatProps} />;
}
